import React, { useState } from 'react';
import { BaseModal, Button, ToastMessage } from '@cokitchen/cokitchen-components';
import { ReactComponent as ErrorIcon } from 'assets/icons/error.svg';
import { apiService } from 'utils/api';
import { toast } from 'react-toastify';

type Props = {
  show: boolean;
  onClose: (success?: boolean) => void;
  staffName: string;
  id: string;
};

type DeleteStaffModalFooterProps = {
  onClose: (success?: boolean) => void;
  loading: boolean;
  onConfirm: () => void;
};

const DeleteStaffModalFooter = ({ onClose, loading, onConfirm }: DeleteStaffModalFooterProps) => {
  return (
    <div className='w-full flex items-center justify-between mt-4 gap-8'>
      <Button
        onClick={() => onClose()}
        className='border border-gray-5 text-gray-5 hover:bg-gray-5 hover:text-white'
        small
        variant='block'
        color='gray'>
        Cancel
      </Button>
      <Button
        onClick={onConfirm}
        className='bg-red-5 hover:bg-red-6 text-white'
        small
        variant='block'
        color='primary'
        loading={loading}>
        Delete
      </Button>
    </div>
  );
};
const DeleteStaffModal = ({ show, onClose, staffName, id }: Props) => {
  const [loading, setLoading] = useState(false);

  const deleteStaff = async () => {
    setLoading(true);
    try {
      const res = await apiService.delete(`kitchen/staff/${id}`, {
        baseUrl: process.env.REACT_APP_KITCHEN_API_URL
      });
      if (res.status === 200) {
        onClose(true);
        toast(<ToastMessage type='success' message={res.data.message} />);
      }
    } catch (error: any) {
      onClose();
      toast(<ToastMessage type='error' message={error.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };

  return (
    <BaseModal
      bodyOpenClassName={'hide_title_icon'}
      isOpen={show}
      onRequestClose={() => onClose()}
      title=''
      titleIcon={<ErrorIcon />}
      titleIconColor='danger'
      footer={
        <DeleteStaffModalFooter
          onClose={() => onClose()}
          loading={loading}
          onConfirm={deleteStaff}
        />
      }>
      <div className='flex flex-col justify-center items-center'>
        <ErrorIcon className='mx-auto mb-4' />
        <p className='font-medium text-[18px]'>Delete Staff</p>
        <p className='text-sm text-gray-8 text-center'>
          Are you sure you want to delete {staffName}?
        </p>
      </div>
    </BaseModal>
  );
};

export default DeleteStaffModal;
